import React from "react";
import { Wrap, OrbOne, OrbTwo, OrbThree, Grid } from "./HeroBgAnimationStyle";

const HeroBgAnimation = () => (
  <Wrap>
    <Grid />
    <OrbOne />
    <OrbTwo />
    <OrbThree />
  </Wrap>
);

export default HeroBgAnimation;
